export default __webpack_public_path__ + "static/media/navbaricon1.ec6dddc7.png";